var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { AccountItemGroup } from './AccountItemGroup';
import { colors } from '../../../../abstracts';
var StyledList = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n"], ["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n"])));
export var AccountItems = function (_a) {
    var clickHandler = _a.clickHandler, groups = _a.itemGroups;
    return (React.createElement(StyledList, null, groups === null || groups === void 0 ? void 0 : groups.map(function (g, i) { return (React.createElement(AccountItemGroup, { key: "AccountItemGroup-".concat(g.id), textColor: i === groups.length - 1 ? colors.neutralDeeper : colors.black, id: g.id, items: g.items, clickHandler: clickHandler })); })));
};
var templateObject_1;
